import * as React from "react";

function StopRecIcon(props) {
  return (
    <svg
      fill="#fff"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 419.84 419.84"
      className="btnIcon"
      {...props}
    >
      <path d="M209.92 0C93.696 0 0 93.696 0 209.92s93.696 209.92 209.92 209.92 209.92-93.696 209.92-209.92S326.144 0 209.92 0zm82.432 268.288c0 12.8-10.24 23.552-23.552 23.552H151.552c-12.8 0-23.552-10.24-23.552-23.552l.512-116.736c0-12.8 10.24-23.552 23.552-23.552H268.8c12.8 0 23.552 10.24 23.552 23.552v116.736z" />
    </svg>
  );
}

export default StopRecIcon;
